import './DicomTags.css';

const DicomTags = ({ metadata, windowCenter, windowWidth, windowPresets }) => {
    if (!metadata) return null;

    return (
        <div className="panel dicom-tags">
            <h3 className="panel-title">DICOM Tags</h3>
            <table className="table-dicom">
                <thead>
                    <tr>
                        <th>Tag</th>
                        <th>Description</th>
                        <th>Original Value</th>
                        <th>Current Value</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="tag-mono">(0028,1050)</td>
                        <td>Window Center</td>
                        <td>{metadata.windowCenter}</td>
                        <td className={`current-value ${windowCenter !== metadata.windowCenter ? 'changed' : ''}`}>
                            {windowCenter}
                        </td>
                    </tr>
                    <tr>
                        <td className="tag-mono">(0028,1051)</td>
                        <td>Window Width</td>
                        <td>{metadata.windowWidth}</td>
                        <td className={`current-value ${windowWidth !== metadata.windowWidth ? 'changed' : ''}`}>
                            {windowWidth}
                        </td>
                    </tr>
                    <tr>
                        <td className="tag-mono">(0028,1052)</td>
                        <td>Rescale Intercept</td>
                        <td>{metadata.rescaleIntercept}</td>
                        <td>{metadata.rescaleIntercept}</td>
                    </tr>
                    <tr>
                        <td className="tag-mono">(0028,1053)</td>
                        <td>Rescale Slope</td>
                        <td>{metadata.rescaleSlope}</td>
                        <td>{metadata.rescaleSlope}</td>
                    </tr>
                    {windowPresets && windowPresets.length > 0 && (
                        <tr>
                            <td className="tag-mono">(0028,1055)</td>
                            <td>Window Presets</td>
                            <td colSpan={2}>
                                {windowPresets.map((p, i) => `${p.name} (C:${p.center}, W:${p.width})`).join('; ')}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <div className="small-muted">
                Image Dimensions: {metadata.columns} × {metadata.rows} pixels
            </div>
        </div>
    );
};

export default DicomTags;
